"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getClassNames = utilities_1.memoizeFunction(function (styles, className) {
    return {
        root: styling_1.mergeStyles("file-field", className, styles.root),
        wrapper: styling_1.mergeStyles("file-field-wrapper", styles.wrapper),
        selector: styling_1.mergeStyles("file-field-selector", styles.selector),
        selectorAction: styling_1.mergeStyles("file-field-selector-action", styles.selectorAction)
    };
});
exports.getClassNames = getClassNames;
